import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Image from "react-bootstrap/Image";
import { Tabs, Tab } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";

import { ReadMore } from "../../components/ReadMore";

import { motion } from "framer-motion";

import { useEffect, useState } from "react";


interface Publication {
  title: string;
  date: string;
  type: string;
  abstract: string;
  link: string;
  image: string;
  "sjr-id": string | null;
  authors: string;
}

//Use state calls this function
export const Publications = () => {
  useEffect(() => {
    document.title = "Mohamad Tarabin - Publications";
  }, []);

  const [filter, setFilter] = useState<string>("All");

  const publicationsJSON = require("./publications.json");
  const publicationList: Publication[] = publicationsJSON.publications;

  const allCount = publicationList.length;
  const journalCount = publicationList.filter(p => p.type === "Journal Article").length;
  const conferenceCount = publicationList.filter(p => p.type === "Conference Paper").length;

  const filteredPublications = publicationList.filter(pub => {
    if (filter == "All") return true;
    return pub.type == filter;
  });

  // The below is not updated on window resize but I don't care.
  const isMobile = window.innerWidth < 768;


  return (
    <>
      {/* Container is not exactly necessary, but it is better for organized spacing */}
      <Container>
        <h3
          style={{
            marginTop: "30px",
            marginBottom: "30px",
          }}
        >
          Publications{" "}
          {/* <span style={{ color: "gray" }}>({filteredPublications.length})</span> */}
        </h3>

      <Tabs
        activeKey={filter}
        onSelect={(k) => {
        if (k !== null) {
          setFilter(k);
        }
        }}
        className="custom-tabs mb-4"
      >
        <Tab eventKey="All" title={`All (${allCount})`} />
        <Tab eventKey="Journal Article" title={`Journal Articles (${journalCount})`} />
        <Tab eventKey="Conference Paper" title={`Conference Papers (${conferenceCount})`} />
      </Tabs>

        <motion.div
            key={filter}
            className="publications-container"
            initial={{ opacity: 0}}
            animate={{ opacity: 1}}
            transition={{ duration: 0.25 }}
          >
          {filteredPublications.map((publication) => (
            // <Row>
            //mx-auto means margin x auto. This is a feature in bootstrap
            // className="my-5" -> Means margin y is set to 5
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.6 }}
            >
              <Card>
                {/* <Card.Img variant="top" src="holder.js/100px180" /> */}
                <Card.Header>{publication.type}</Card.Header>
                <Card.Body>
                  <Container fluid>
                    <Row>


                      {/* <Col class="col-7"> */}
                      <Col
                        xs={{ span: 12, order: 0 }}
                        lg={{ span: 7, order: 0 }}
                      >
                        <Card.Title className="justify-text bold">
                          {publication.title}
                        </Card.Title>

                        <Card.Text className="muted-text mb-1">
                          {publication.authors}
                        </Card.Text>

                        <Card.Subtitle className="muted-text mb-2">
                          {publication.date}
                        </Card.Subtitle>

                        <Card.Text className="justify-text">
                          <ReadMore charlimit={isMobile ? 500 : 1000}>
                            {"Abstract: " + publication.abstract}
                          </ReadMore>
                        </Card.Text>

                      </Col>

                      {/* Image and view publciation button */}
                      {/* Image and view publciation button */}
                      {/* Image and view publciation button */}
                      <Col
                      // class="col-5"
                      >
                        {/* You make the row 'relative' so that whatever uses absolute position is relative to this row */}
                        <Row style={{ position: "relative" }}>
                          {publication.image != undefined ? (
                            <Image
                              src={publication.image}
                              fluid
                              className="my-2"
                            />
                          ) : null}
                          {/* {publication["sjr-id"] != undefined ? (
                            <a
                              href={
                                "https://www.scimagojr.com/journalsearch.php?q=" +
                                publication["sjr-id"] +
                                "&tip=sid&exact=no"
                              }
                            >
                              <Image
                                src={
                                  "https://www.scimagojr.com/journal_img.php?id=" +
                                  publication["sjr-id"]
                                }
                                style={{
                                  width: "25%",
                                  // height: "40%",
                                  position: "absolute",
                                  top: "2%",
                                  right: "2%",
                                }}
                              />
                            </a>
                          ) : null} */}
                        </Row>

                        <Row>
                          <Col className="text-center">
                            <Button
                              variant="primary"
                              href={publication.link}
                              className="my-2"
                            >
                              View publication
                            </Button>
                          </Col>
                        </Row>
                      </Col>



                    </Row>
                  </Container>
                </Card.Body>
              </Card>
            </motion.div>
            // </Row>
          ))}
        </motion.div>
      </Container>
    </>
  );
};
